import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand */}
        <div style={{gridColumn: 'span 2'}}>
          <div className="footer-brand">
            {/*<div className="footer-logo"></div>*/}
            <span className="footer-title">VentureOS</span>
          </div>
          <p className="footer-description">
            The global operating system for venture capital, powering data-driven decisions across all private markets.
          </p>
        </div>

        {/* Product */}
        <div className="footer-section">
          <h3>Product</h3>
          <ul className="footer-links">
            <li><a href="/#features">Features</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/api">API</a></li>
            <li><a href="/documentation">Documentation</a></li>
          </ul>
        </div>

        {/* Company */}
        <div className="footer-section">
          <h3>Company</h3>
          <ul className="footer-links">
            <li><a href="/about">About</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/careers">Careers</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © 2025 VentureOS. All rights reserved.
        </p>
        <div className="footer-legal">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
